/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Cta_TitleInputs */

const en_fw_cta_title = /** @type {(inputs: Fw_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A love story told in borrowed time`)
};

const zh_fw_cta_title = /** @type {(inputs: Fw_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一段在借来的时光里讲述的爱情`)
};

/**
* | output |
* | --- |
* | "A love story told in borrowed time" |
*
* @param {Fw_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_cta_title = /** @type {((inputs?: Fw_Cta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Cta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_cta_title(inputs)
	return zh_fw_cta_title(inputs)
});
export { fw_cta_title as "fw.cta.title" }